export default __webpack_public_path__ + "static/media/hero-video-compressed-new-x265.d7eeb86c.mp4";